export function parallax() {
    let animateElement = $('.has-parallax');
    let scrolled = $(window).scrollTop();
    let addHeight = parseInt(window.innerHeight * 1.25);
    let $body = $("body");
    let speed;

    $(window).on('scroll load', function () {
        let isIE = !!document.documentMode;

        scrolled = $(window).scrollTop();
        animateElement.each(function () {
            let $this = $(this);
            $this.hasClass("fast") ? speed = 7 : speed = 10;
            if ($this.hasClass("bottom")) {
                speed = "-" + speed;
            }
            let elementTop = parseInt($this.offset().top);

            if ((scrolled + addHeight) >= elementTop && (scrolled + addHeight) < elementTop + addHeight) {
                $this.css({"transform": "translateY(" + parseInt((scrolled - elementTop) / speed) + "px)"});
            }

            if (!$body.hasClass("no-touch") || window.innerWidth < 1200 || isIE) {
                $this.css({"transform": "translateY(0px)"});
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/parallax.js